import { PKPEthersWallet } from '@lit-protocol/pkp-ethers';
import { ethers } from 'ethers';
import { LitContracts } from '@lit-protocol/contracts-sdk';
import { LitNodeClient } from '@lit-protocol/lit-node-client';
export const getLitContractClient = async (pkpPublicKey, sessionSig) => {
  if (!global._litContract) {
    global._litContract = {};
  }
  const key = `${pkpPublicKey}-${sessionSig[Object.keys(sessionSig)[0]]['sig']}`;
  if (!global._litContract[key]) {
    const litProvider = new ethers.providers.JsonRpcProvider(process.env.NEXT_PUBLIC_LIT_RPC);
    const litNodeClient = new LitNodeClient({
      litNetwork: process.env.NEXT_PUBLIC_LIT_NETWORK,
      debug: false,
      rpcUrl: process.env.NEXT_PUBLIC_LIT_RPC
    });
    await litNodeClient.connect();
    global._litContract[key] = new LitContracts({
      provider: litProvider,
      network: process.env.NEXT_PUBLIC_LIT_NETWORK,
      rpc: process.env.NEXT_PUBLIC_LIT_RPC,
      signer: new PKPEthersWallet({
        pkpPubKey: pkpPublicKey,
        controllerSessionSigs: sessionSig,
        rpc: process.env.NEXT_PUBLIC_LIT_RPC,
        provider: litProvider,
        litNodeClient
      })
    });
    await global._litContract[key].connect();
  } else if (!global._litContract[key].connected) {
    await global._litContract[key].connect();
  }
  return global._litContract[key];
};